// removed by extract-text-webpack-plugin
module.exports = {"textArea":"AutoResizeTextArea__textArea__R-p2Y"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Input/AutoResizeTextArea/AutoResizeTextArea.scss
// module id = 1724
// module chunks = 0